import * as React from "react";

/**
 * Tracks browser connectivity for the offline patterns.
 *
 * `navigator.onLine` only proves the machine has a network interface, so treat
 * it as a hint that a request is pointless rather than as proof the API is
 * reachable. A failed request remains the authority.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = React.useState(() =>
    typeof navigator === "undefined" ? true : navigator.onLine !== false,
  );

  React.useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return online;
}
